import Experience from "./Experience";
import gsap from "gsap";

export default class HTML {
  constructor() {
    this.experience = new Experience();
    this.body = document.querySelector("body");
    this.canvas = this.experience.canvas;
    this.resources = this.experience.resources;
    this.mobile = this.experience.size.mobileSize;

    //! html

    //? animate background
    this.bg = document.createElement("div");
    this.bg.classList.add("bg");
    this.bgContent = `
    <div class="img-con">
      <img src="/textures/crepe_logo.png" alt="logo">

      </div>
      <svg
  class="container" 
  x="0px" 
  y="0px"
  viewBox="0 0 55 23.1"
  height="23.1"
  width="55"
  preserveAspectRatio='xMidYMid meet'
>
  <path
    class="track" 
    fill="none" 
    stroke-width="4" 
    pathlength="100"
    d="M26.7,12.2c3.5,3.4,7.4,7.8,12.7,7.8c5.5,0,9.6-4.4,9.6-9.5C49,5,45.1,1,39.8,1c-5.5,0-9.5,4.2-13.1,7.8l-3.4,3.3c-3.6,3.6-7.6,7.8-13.1,7.8C4.9,20,1,16,1,10.5C1,5.4,5.1,1,10.6,1c5.3,0,9.2,4.5,12.7,7.8L26.7,12.2z"
  />
  <path
    class="car" 
    fill="none" 
    stroke-width="4" 
    pathlength="100"
    d="M26.7,12.2c3.5,3.4,7.4,7.8,12.7,7.8c5.5,0,9.6-4.4,9.6-9.5C49,5,45.1,1,39.8,1c-5.5,0-9.5,4.2-13.1,7.8l-3.4,3.3c-3.6,3.6-7.6,7.8-13.1,7.8C4.9,20,1,16,1,10.5C1,5.4,5.1,1,10.6,1c5.3,0,9.2,4.5,12.7,7.8L26.7,12.2z"
  />
</svg>


      `;
    this.bg.innerHTML = this.bgContent;
    this.body.appendChild(this.bg);

    this.navImage = document.createElement("div");
    this.navImage.classList.add("nav-con");
    this.navImage.innerHTML = `
           <img src="/textures/navigation.png" alt="" />

    `;

    //?
    this.logoContainer = document.createElement("div");
    this.logoContainer.classList.add("inside-logo");
    this.logoContainer.innerHTML = `
      <img src="/textures/crepe_logo.png" alt="" />
    `;

    // this.body.append(this.logoContainer);
    //! BUTTON - CONTAINER
    this.buttonContainer = document.createElement("div");
    this.buttonContainer.classList.add("buttons-con");

    this.buttonContainer.innerHTML = `

      <div class="button-con-inner"> 
        <button class="button menu">Menu</button>
        <button class="button reserve">Demander un devis</button>
      </div>
      <div class="button-con-inner">
        <button class="button family">CRÊPES FAMILY</button>
        <button class="button pop">Partenaires</button>
      </div>
       <div class="button-con-inner">
        <button class="button documents-btn">DOCUMENTS & INFOS</button>
      </div>
    `;

    this.body.append(this.buttonContainer);

    //? about con
    this.infoContainer = document.createElement("div");
    this.infoContainer.classList.add("con-design");
    this.infoContainer.classList.add("about-con");
    this.closeAboutBtn = document.createElement("div");
    this.closeAboutBtn.classList.add("close-btn");

    this.infoContainer.innerHTML = `
      <div class=" close-about-con close-con">
        <h3 class="con-title">Pop Up</h3>
        <div class="close-btn"></div>
      </div>


    
    `;

    this.body.append(this.infoContainer);

    this.aboutUs = document.createElement("div");
    this.aboutUs.classList.add("information-con");
    this.aboutUs.classList.add("crepe-about");

    this.aboutUs.innerHTML = `
            <p>La Crêpes Family est une jeune crêperie mobile genevoise. La Crêpes Family puise
son inspiration dans les recettes bretonnes pour réinventer la crêpe à sa façon.</p>
            <p>Son Food-Truck ainsi que ses stands de crêpes chaleureux et conviviaux s’intègrent
parfaitement à tout type d’événement, public ou privé.</p>
            <p>Au menu dans notre restaurant mobile : crêpes sucrées,galettes de sarrasin, smash
pancakes mais encore des banquets gourmands de créations sucrées-salées sur
mesure, pour ravir petits et grands.</p>
            <p>Ancrée dans l’Économie Sociale et Solidaire, L’association Crêpes Family
sélectionne exclusivement des produits locaux pour une dégustation responsable et
délicieuse, tout en mobilisant et en accompagnant des jeunes en insertion
professionnelle vers un emploi durable.</p>
<p>Réservez-nous pour un moment festif et solidaire !</p>
    `;

    this.infoContainer.append(this.aboutUs);

    //? pop up

    this.documentsHTML = document.createElement("div");
    this.documentsHTML.classList.add("information-con");
    this.documentsHTML.classList.add("documents-con");

    //  <div class="popup-small-con">
    //    <div>Hroaire:</div>
    //    <div class="popup-weight">12h - 18h</div>
    //  </div>;

    this.documentsHTML.innerHTML = `
        <div class="document-inner-con">
        <img src="../textures/activities-img.png">
         <a href="../activities.pdf" download="Crêpes Family - RAPPORT D'ACTIVITES 2025">Download</a>
        </div>

         <div class="document-inner-con">
        <img src="../textures/presentation.png">
         <a href="../presentation.pdf" download="PDF PRESENTATION CREPES FAMILY 2026">Download</a>
        </div>

          <div class="document-inner-con">
        <img src="../textures/remobilisation.png">
         <a href="../travail_de_bachelor.pdf" download="Travail de Bachelor V4">Download</a>
        </div>


    `;

    this.infoContainer.append(this.documentsHTML);

    //? form

    this.form = document.createElement("form");
    this.form.classList.add("information-con");
    this.form.classList.add("form");
    this.result = document.createElement("div");
    this.result.classList.add("result");

    this.resultRecieved = document.createElement("h2");
    this.resultRecieved.innerHTML = "Merci pour votre confiance!";

    this.form.innerHTML = `
           


     <input
        type="hidden"
        name="access_key"
        value="2a9244ab-2dcf-47c1-a1dd-75e720e7adca"
      />

    <input type="hidden" name="subject" value="Crepe, you have a new order!">
    <input type="checkbox" name="botcheck" id="" style="display: none;">

    <!-- Custom Form Data -->
    <div class="form-data">
      <label>Nom et prénom:</label>
      <input type="text" name="name" placeholder="e.x John Doe" required>
    </div>

     <div class="form-data">
      <label>Email:</label>
      <input type="email" name="email" placeholder="e.x yourname@gmail.com" required>
    </div>

      <div class="form-data">
      <label>Numéro de téléphone:</label>
      <input type="number" name="phoneNumber" placeholder="0041 88 200 32 74" required>
    </div>

     <div class="form-data">
      <label>Date:</label>
      <input type="date" name="date"  required>
    </div>

     <div class="form-data">
      <label>Budget:</label>
      <input type="number" name="budget" step=".25" placeholder="240CHF">
      <span class="euro-sign">CHF</span>
    </div>

      <div class="form-data">
      <label>Description:</label>
      <textarea class="description-input" name="Description" placeholder="Your message" rows="5"></textarea>
    </div>

    <button type="submit">Soumettre</button>


    `;
    this.form.append(this.result);
    this.infoContainer.append(this.form);
    //? form submit
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(this.form);

      const object = Object.fromEntries(formData);
      object.budget = `${object.budget}€`;

      const json = JSON.stringify(object);
      this.result.innerHTML = "Please wait...";

      fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      })
        .then(async (response) => {
          let json = await response.json();
          if (response.status == 200) {
            this.form.innerHTML = "";
            console.log(this.form.style);
            this.form.style.overflow = "hidden";
            this.form.append(this.resultRecieved);

            // this.result.innerHTML = json.message;
            // this.result.style.color = "#000000";
          } else {
            this.result.innerHTML = json.message;
            this.result.style.color = "#ff0000";
          }
        })
        .catch((error) => {
          this.result.innerHTML = "Something went wrong!";
          this.result.style.color = "#ff0000";
        });
    });

    //? pdf document download
    this.activitiesPDF = document.createElement("a");
    this.activitiesPDF.href = "../activities.pdf";
    this.activitiesPDF.download = "Crepe_Activities.pdf";

    this.presentationPDF = document.createElement("a");
    this.presentationPDF.href = "../presentation.pdf";
    this.presentationPDF.download = "Crepe_presentation.pdf";

    this.travailDeBachelorPDF = document.createElement("a");
    this.travailDeBachelorPDF.href = "../travail_de_bachelor.pdf";
    this.travailDeBachelorPDF.download = "Crepe_travail_de_bachelor.pdf";
    //? title
    this.title = document.querySelector(".con-title");
    this.closeInfoButton = document.querySelector(".close-btn");

    //? socials

    this.socialsContainer = document.createElement("div");
    this.socialsContainer.classList.add("socials-con");
    this.socialsContainer.innerHTML = `
      <a href="https://www.instagram.com/crepe.family/">
        <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" >
          <path  d="M18.3952 7.02212C17.6005 7.02368 16.9543 6.3802 16.9528 5.58548C16.9512 4.79076 17.5947 4.14457 18.3898 4.14302C19.1848 4.14146 19.831 4.78531 19.8326 5.58004C19.8338 6.37476 19.1903 7.02057 18.3952 7.02212Z" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0115 18.161C8.60909 18.1676 5.8451 15.4149 5.8385 12.0117C5.83188 8.60923 8.58536 5.84481 11.9878 5.8382C15.3909 5.83159 18.1553 8.5859 18.1619 11.9879C18.1685 15.3912 15.4143 18.1544 12.0115 18.161ZM11.992 8.00035C9.78365 8.00424 7.99594 9.79858 7.99983 12.0074C8.0041 14.2166 9.79882 16.0039 12.0072 15.9996C14.2164 15.9954 16.0041 14.2014 15.9998 11.9922C15.9955 9.78302 14.2008 7.99608 11.992 8.00035Z"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.1192 0.646479C4.88126 0.347876 5.75333 0.143362 7.03015 0.0830982C8.31011 0.0216726 8.71872 0.00767102 11.9769 0.00145262C15.2358 -0.00476578 15.6444 0.00766862 16.9244 0.0644334C18.2016 0.119643 19.0741 0.321049 19.8377 0.616544C20.6277 0.920974 21.298 1.33078 21.966 1.99603C22.6339 2.66205 23.0453 3.33002 23.3536 4.1189C23.6518 4.88174 23.8563 5.75306 23.917 7.03068C23.9776 8.31023 23.9924 8.71847 23.9986 11.9771C24.0048 15.2353 23.9916 15.6443 23.9356 16.925C23.88 18.2014 23.679 19.0743 23.3835 19.8375C23.0783 20.6276 22.6693 21.2979 22.004 21.9659C21.3388 22.6342 20.6701 23.0452 19.8812 23.3539C19.1184 23.6517 18.2471 23.8562 16.9702 23.9173C15.6903 23.9779 15.2817 23.9923 12.0224 23.9985C8.76459 24.0048 8.35598 23.9923 7.07605 23.9359C5.79882 23.88 4.92597 23.6789 4.16275 23.3838C3.37271 23.0782 2.70242 22.6696 2.03446 22.004C1.36611 21.3383 0.954386 20.67 0.646458 19.8811C0.347858 19.1186 0.144107 18.2469 0.0830727 16.9705C0.0220359 15.6901 0.00765506 15.2811 0.00143906 12.0229C-0.00480094 8.76435 0.00803667 8.35611 0.0640167 7.07616C0.1204 5.79855 0.320637 4.92606 0.61613 4.16206C0.921328 3.37239 1.33035 2.70248 1.99637 2.03413C2.6616 1.36616 3.33033 0.954017 4.1192 0.646479ZM4.94154 21.3679C5.36494 21.5308 6.00023 21.7252 7.17014 21.7761C8.43607 21.8309 8.81514 21.843 12.0185 21.8368C15.223 21.8309 15.6021 21.8173 16.8676 21.7579C18.0363 21.7022 18.6716 21.5055 19.0939 21.3407C19.6541 21.1218 20.0531 20.8601 20.4722 20.4406C20.8913 20.0195 21.1506 19.6194 21.3676 19.0591C21.5309 18.6354 21.7249 17.9996 21.7758 16.8297C21.8314 15.5646 21.8431 15.1851 21.8368 11.9809C21.831 8.77757 21.8174 8.3981 21.7572 7.13254C21.7019 5.96339 21.5056 5.32808 21.3404 4.90623C21.1215 4.34519 20.8606 3.94705 20.4399 3.52753C20.0192 3.10801 19.6191 2.84945 19.0581 2.6325C18.6355 2.46881 17.9994 2.27518 16.8303 2.22426C15.5643 2.16865 15.1849 2.15737 11.9808 2.1636C8.77743 2.16982 8.39836 2.18264 7.13281 2.24253C5.9633 2.29812 5.32877 2.49447 4.90575 2.65972C4.34587 2.87861 3.94696 3.13872 3.52746 3.5598C3.10871 3.98087 2.84938 4.38018 2.63244 4.94161C2.46993 5.36464 2.27434 6.00072 2.2242 7.16987C2.16898 8.43581 2.15733 8.81529 2.16355 12.0187C2.16939 15.2228 2.18298 15.6023 2.24248 16.8671C2.29729 18.037 2.49518 18.6715 2.65966 19.0949C2.87855 19.6544 3.13944 20.0533 3.55973 20.4729C3.98081 20.8908 4.38088 21.1509 4.94154 21.3679Z" />
        </svg>
      </a>
      <a href="https://www.tiktok.com/@crepesfamily">
        <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24">
          <path  d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z" />
        </svg>
      </a>

      <a href="mailto:crepefamily2021@gmail.com">
        <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" >
          <path d="M5.45455 21.0045H1.63636C0.733636 21.0045 0 20.2736 0 19.3681V5.45919C0 3.43555 2.30727 2.28191 3.92727 3.49555L12 9.54996L20.0727 3.49555C21.69 2.28191 24 3.43555 24 5.45919V19.3681C24 20.2709 23.2691 21.0045 22.3636 21.0045H18.5454V11.7318L12 16.6409L5.45456 11.7318L5.45455 21.0045Z" />
        </svg>
      </a>

      <a href="https://wa.me/41774004943">
        <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" >
          <path d="M0 24L1.687 17.837C0.646 16.033 0.099 13.988 0.1 11.891C0.103 5.335 5.438 0 11.993 0C15.174 0.001 18.16 1.24 20.406 3.488C22.651 5.736 23.887 8.724 23.886 11.902C23.883 18.459 18.548 23.794 11.993 23.794C10.003 23.793 8.042 23.294 6.305 22.346L0 24ZM6.597 20.193C8.273 21.188 9.873 21.784 11.989 21.785C17.437 21.785 21.875 17.351 21.878 11.9C21.88 6.438 17.463 2.01 11.997 2.008C6.545 2.008 2.11 6.442 2.108 11.892C2.107 14.117 2.759 15.783 3.854 17.526L2.855 21.174L6.597 20.193ZM17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382C17.117 14.233 15.656 13.514 15.383 13.415C15.111 13.316 14.913 13.266 14.714 13.564C14.516 13.861 13.946 14.531 13.773 14.729C13.6 14.927 13.426 14.952 13.129 14.803C12.832 14.654 11.874 14.341 10.739 13.328C9.856 12.54 9.259 11.567 9.086 11.269C8.913 10.972 9.068 10.811 9.216 10.663C9.35 10.53 9.513 10.316 9.662 10.142C9.813 9.97 9.862 9.846 9.962 9.647C10.061 9.449 10.012 9.275 9.937 9.126C9.862 8.978 9.268 7.515 9.021 6.92C8.779 6.341 8.534 6.419 8.352 6.41L7.782 6.4C7.584 6.4 7.262 6.474 6.99 6.772C6.718 7.07 5.95 7.788 5.95 9.251C5.95 10.714 7.015 12.127 7.163 12.325C7.312 12.523 9.258 15.525 12.239 16.812C12.948 17.118 13.502 17.301 13.933 17.438C14.645 17.664 15.293 17.632 15.805 17.556C16.376 17.471 17.563 16.837 17.811 16.143C18.059 15.448 18.059 14.853 17.984 14.729Z" />
        </svg>
      </a>

    `;

    this.body.append(this.socialsContainer);

    this.resources.on("resourcesReady", () => {
      gsap.to(".bg", {
        duration: 2,
        opacity: 0,
        y: 0,
        ease: "ease-out",
        display: "none",
        onComplete: () => {
          document.querySelector(".buttons-con").style.display = "flex";
          document.querySelector(".socials-con").style.display = "flex";

          gsap.to(this.navImage, {
            duration: 0.5,
            opacity: 1,
          });
          gsap.to(".buttons-con", {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "back.out(1.7)",
          });
          gsap.to(".socials-con", {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "back.out(1.7)",
          });
        },
      });
    });
  }

  update() {}
}
